<div class="image-frame">
  @if (value) {
    <img [src]="value.imageUrl" alt="Selected image" />
  }
  @else if (fallbackUrl) {
    <div class="image-fallback">
      <img [src]="fallbackUrl" alt="Default image" />
      @if (fallbackNote) {
        <div class="fallback-note">{{ fallbackNote }}</div>
      }
    </div>
  }
  @else {
    <span class="image-placeholder"></span>
  }

  @if (badgeLabel) {
    <span class="image-badge">{{ badgeLabel }}</span>
  }
  @if (value?.size) {
    <span class="image-badge image-badge-size">{{ value.size.width }} &times; {{ value.size.height }}</span>
  }
</div>

<mgd-file-selector
  #fileSelector
  [hidden]="true"
  [acceptedTypes]="acceptedTypes"
  [listenForPaste]="listenForPaste"
  (selected)="onFileSelected($event)" />

<div class="image-actions">
  <button mat-raised-button mgdButton type="button" class="mat-upload-button" [disabled]="isDisabled"
          (click)="fileSelector.openFileSelectorDialog()">{{ uploadButtonLabel }}</button>
  @if (value?.blob) {
    <button mat-raised-button mgdButton type="button" class="mat-crop-button" [disabled]="isDisabled"
            (click)="onCropClick()">{{ cropButtonLabel }}</button>
  }
  @if (listenForPaste && !isDisabled && pasteHintLabel) {
    <span class="image-paste-hint">{{ pasteHintLabel }}</span>
  }
  <ng-content />
</div>
